/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from '@tanstack/react-query';
import { useInformApiContext, InformApiContext } from './informApiContext';
import type * as Fetcher from './informApiFetcher';
import { informApiFetch } from './informApiFetcher';
import type * as Schemas from './informApiSchemas';
import type { ClientErrorStatus, ServerErrorStatus } from './informApiUtils';

export type AppControllerGetHelloError = Fetcher.ErrorWrapper<undefined>;

export type AppControllerGetHelloVariables = InformApiContext['fetcherOptions'];

export const fetchAppControllerGetHello = (
  variables: AppControllerGetHelloVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<string, AppControllerGetHelloError, undefined, {}, {}, {}>({
    url: '/',
    method: 'get',
    ...variables,
    signal,
  });

export const useAppControllerGetHello = <TData = string>(
  variables: AppControllerGetHelloVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<string, AppControllerGetHelloError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<string, AppControllerGetHelloError, TData>(
    queryKeyFn({ path: '/', operationId: 'appControllerGetHello', variables }),
    ({ signal }) =>
      fetchAppControllerGetHello({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type UserControllerGetMeError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 200>;
  payload: Schemas.SerializedUser;
}>;

export type UserControllerGetMeVariables = InformApiContext['fetcherOptions'];

export const fetchUserControllerGetMe = (
  variables: UserControllerGetMeVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.SerializedUser,
    UserControllerGetMeError,
    undefined,
    {},
    {},
    {}
  >({ url: '/users/me', method: 'get', ...variables, signal });

export const useUserControllerGetMe = <TData = Schemas.SerializedUser>(
  variables: UserControllerGetMeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SerializedUser,
      UserControllerGetMeError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<
    Schemas.SerializedUser,
    UserControllerGetMeError,
    TData
  >(
    queryKeyFn({
      path: '/users/me',
      operationId: 'userControllerGetMe',
      variables,
    }),
    ({ signal }) =>
      fetchUserControllerGetMe({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type UserControllerUpdateMeError = Fetcher.ErrorWrapper<undefined>;

export type UserControllerUpdateMeVariables = {
  body: Schemas.UpdateUserDto;
} & InformApiContext['fetcherOptions'];

export const fetchUserControllerUpdateMe = (
  variables: UserControllerUpdateMeVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.SerializedUser,
    UserControllerUpdateMeError,
    Schemas.UpdateUserDto,
    {},
    {},
    {}
  >({ url: '/users/me', method: 'post', ...variables, signal });

export const useUserControllerUpdateMe = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SerializedUser,
      UserControllerUpdateMeError,
      UserControllerUpdateMeVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    Schemas.SerializedUser,
    UserControllerUpdateMeError,
    UserControllerUpdateMeVariables
  >(
    (variables: UserControllerUpdateMeVariables) =>
      fetchUserControllerUpdateMe({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type UserControllerDeleteMeError = Fetcher.ErrorWrapper<undefined>;

export type UserControllerDeleteMeVariables =
  InformApiContext['fetcherOptions'];

export const fetchUserControllerDeleteMe = (
  variables: UserControllerDeleteMeVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<boolean, UserControllerDeleteMeError, undefined, {}, {}, {}>({
    url: '/users/me',
    method: 'delete',
    ...variables,
    signal,
  });

export const useUserControllerDeleteMe = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      boolean,
      UserControllerDeleteMeError,
      UserControllerDeleteMeVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    boolean,
    UserControllerDeleteMeError,
    UserControllerDeleteMeVariables
  >(
    (variables: UserControllerDeleteMeVariables) =>
      fetchUserControllerDeleteMe({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type AuthControllerGoogleAuthError = Fetcher.ErrorWrapper<undefined>;

export type AuthControllerGoogleAuthVariables =
  InformApiContext['fetcherOptions'];

export const fetchAuthControllerGoogleAuth = (
  variables: AuthControllerGoogleAuthVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Record<string, any>,
    AuthControllerGoogleAuthError,
    undefined,
    {},
    {},
    {}
  >({ url: '/auth/google', method: 'get', ...variables, signal });

export const useAuthControllerGoogleAuth = <TData = Record<string, any>>(
  variables: AuthControllerGoogleAuthVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Record<string, any>,
      AuthControllerGoogleAuthError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<
    Record<string, any>,
    AuthControllerGoogleAuthError,
    TData
  >(
    queryKeyFn({
      path: '/auth/google',
      operationId: 'authControllerGoogleAuth',
      variables,
    }),
    ({ signal }) =>
      fetchAuthControllerGoogleAuth(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type OrganizationControllerGetMyOrganizationsQueryParams = {
  take?: number;
  skip?: number;
};

export type OrganizationControllerGetMyOrganizationsError =
  Fetcher.ErrorWrapper<undefined>;

export type OrganizationControllerGetMyOrganizationsResponse =
  Schemas.Pagination & {
    items?: Schemas.SerializedOrganization[];
  };

export type OrganizationControllerGetMyOrganizationsVariables = {
  queryParams?: OrganizationControllerGetMyOrganizationsQueryParams;
} & InformApiContext['fetcherOptions'];

export const fetchOrganizationControllerGetMyOrganizations = (
  variables: OrganizationControllerGetMyOrganizationsVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    OrganizationControllerGetMyOrganizationsResponse,
    OrganizationControllerGetMyOrganizationsError,
    undefined,
    {},
    OrganizationControllerGetMyOrganizationsQueryParams,
    {}
  >({ url: '/organizations', method: 'get', ...variables, signal });

export const useOrganizationControllerGetMyOrganizations = <
  TData = OrganizationControllerGetMyOrganizationsResponse,
>(
  variables: OrganizationControllerGetMyOrganizationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      OrganizationControllerGetMyOrganizationsResponse,
      OrganizationControllerGetMyOrganizationsError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<
    OrganizationControllerGetMyOrganizationsResponse,
    OrganizationControllerGetMyOrganizationsError,
    TData
  >(
    queryKeyFn({
      path: '/organizations',
      operationId: 'organizationControllerGetMyOrganizations',
      variables,
    }),
    ({ signal }) =>
      fetchOrganizationControllerGetMyOrganizations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type OrganizationControllerCreateOrganizationError =
  Fetcher.ErrorWrapper<undefined>;

export type OrganizationControllerCreateOrganizationVariables = {
  body: Schemas.CreateOrganizationDto;
} & InformApiContext['fetcherOptions'];

export const fetchOrganizationControllerCreateOrganization = (
  variables: OrganizationControllerCreateOrganizationVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.SerializedOrganization,
    OrganizationControllerCreateOrganizationError,
    Schemas.CreateOrganizationDto,
    {},
    {},
    {}
  >({ url: '/organizations', method: 'post', ...variables, signal });

export const useOrganizationControllerCreateOrganization = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SerializedOrganization,
      OrganizationControllerCreateOrganizationError,
      OrganizationControllerCreateOrganizationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    Schemas.SerializedOrganization,
    OrganizationControllerCreateOrganizationError,
    OrganizationControllerCreateOrganizationVariables
  >(
    (variables: OrganizationControllerCreateOrganizationVariables) =>
      fetchOrganizationControllerCreateOrganization({
        ...fetcherOptions,
        ...variables,
      }),
    options,
  );
};

export type OrganizationControllerGetOrganizationPathParams = {
  id: string;
};

export type OrganizationControllerGetOrganizationError =
  Fetcher.ErrorWrapper<undefined>;

export type OrganizationControllerGetOrganizationVariables = {
  pathParams: OrganizationControllerGetOrganizationPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchOrganizationControllerGetOrganization = (
  variables: OrganizationControllerGetOrganizationVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.SerializedOrganization,
    OrganizationControllerGetOrganizationError,
    undefined,
    {},
    {},
    OrganizationControllerGetOrganizationPathParams
  >({ url: '/organizations/{id}', method: 'get', ...variables, signal });

export const useOrganizationControllerGetOrganization = <
  TData = Schemas.SerializedOrganization,
>(
  variables: OrganizationControllerGetOrganizationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SerializedOrganization,
      OrganizationControllerGetOrganizationError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<
    Schemas.SerializedOrganization,
    OrganizationControllerGetOrganizationError,
    TData
  >(
    queryKeyFn({
      path: '/organizations/{id}',
      operationId: 'organizationControllerGetOrganization',
      variables,
    }),
    ({ signal }) =>
      fetchOrganizationControllerGetOrganization(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type OrganizationControllerUpdateOrganizationPathParams = {
  id: string;
};

export type OrganizationControllerUpdateOrganizationError =
  Fetcher.ErrorWrapper<undefined>;

export type OrganizationControllerUpdateOrganizationVariables = {
  body?: Schemas.UpdateOrganizationDto;
  pathParams: OrganizationControllerUpdateOrganizationPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchOrganizationControllerUpdateOrganization = (
  variables: OrganizationControllerUpdateOrganizationVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.SerializedOrganization,
    OrganizationControllerUpdateOrganizationError,
    Schemas.UpdateOrganizationDto,
    {},
    {},
    OrganizationControllerUpdateOrganizationPathParams
  >({ url: '/organizations/{id}', method: 'post', ...variables, signal });

export const useOrganizationControllerUpdateOrganization = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SerializedOrganization,
      OrganizationControllerUpdateOrganizationError,
      OrganizationControllerUpdateOrganizationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    Schemas.SerializedOrganization,
    OrganizationControllerUpdateOrganizationError,
    OrganizationControllerUpdateOrganizationVariables
  >(
    (variables: OrganizationControllerUpdateOrganizationVariables) =>
      fetchOrganizationControllerUpdateOrganization({
        ...fetcherOptions,
        ...variables,
      }),
    options,
  );
};

export type TemplateControllerGetTemplatesPathParams = {
  id: string;
};

export type TemplateControllerGetTemplatesQueryParams = {
  take?: number;
  skip?: number;
};

export type TemplateControllerGetTemplatesError =
  Fetcher.ErrorWrapper<undefined>;

export type TemplateControllerGetTemplatesResponse = Schemas.Pagination & {
  items?: Schemas.SerializedTemplate[];
};

export type TemplateControllerGetTemplatesVariables = {
  pathParams: TemplateControllerGetTemplatesPathParams;
  queryParams?: TemplateControllerGetTemplatesQueryParams;
} & InformApiContext['fetcherOptions'];

export const fetchTemplateControllerGetTemplates = (
  variables: TemplateControllerGetTemplatesVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    TemplateControllerGetTemplatesResponse,
    TemplateControllerGetTemplatesError,
    undefined,
    {},
    TemplateControllerGetTemplatesQueryParams,
    TemplateControllerGetTemplatesPathParams
  >({
    url: '/organizations/{id}/templates',
    method: 'get',
    ...variables,
    signal,
  });

export const useTemplateControllerGetTemplates = <
  TData = TemplateControllerGetTemplatesResponse,
>(
  variables: TemplateControllerGetTemplatesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      TemplateControllerGetTemplatesResponse,
      TemplateControllerGetTemplatesError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<
    TemplateControllerGetTemplatesResponse,
    TemplateControllerGetTemplatesError,
    TData
  >(
    queryKeyFn({
      path: '/organizations/{id}/templates',
      operationId: 'templateControllerGetTemplates',
      variables,
    }),
    ({ signal }) =>
      fetchTemplateControllerGetTemplates(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type TemplateControllerCreateTemplatesPathParams = {
  id: string;
};

export type TemplateControllerCreateTemplatesError =
  Fetcher.ErrorWrapper<undefined>;

export type TemplateControllerCreateTemplatesResponse =
  Schemas.SerializedTemplate[];

export type TemplateControllerCreateTemplatesVariables = {
  body: Schemas.AddManyTemplateDto;
  pathParams: TemplateControllerCreateTemplatesPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchTemplateControllerCreateTemplates = (
  variables: TemplateControllerCreateTemplatesVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    TemplateControllerCreateTemplatesResponse,
    TemplateControllerCreateTemplatesError,
    Schemas.AddManyTemplateDto,
    {},
    {},
    TemplateControllerCreateTemplatesPathParams
  >({
    url: '/organizations/{id}/templates',
    method: 'post',
    ...variables,
    signal,
  });

export const useTemplateControllerCreateTemplates = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      TemplateControllerCreateTemplatesResponse,
      TemplateControllerCreateTemplatesError,
      TemplateControllerCreateTemplatesVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    TemplateControllerCreateTemplatesResponse,
    TemplateControllerCreateTemplatesError,
    TemplateControllerCreateTemplatesVariables
  >(
    (variables: TemplateControllerCreateTemplatesVariables) =>
      fetchTemplateControllerCreateTemplates({
        ...fetcherOptions,
        ...variables,
      }),
    options,
  );
};

export type TemplateControllerUpdateTemplatesPathParams = {
  id: string;
};

export type TemplateControllerUpdateTemplatesError =
  Fetcher.ErrorWrapper<undefined>;

export type TemplateControllerUpdateTemplatesResponse =
  Schemas.SerializedTemplate[];

export type TemplateControllerUpdateTemplatesVariables = {
  body: Schemas.UpdateManyTemplateDto;
  pathParams: TemplateControllerUpdateTemplatesPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchTemplateControllerUpdateTemplates = (
  variables: TemplateControllerUpdateTemplatesVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    TemplateControllerUpdateTemplatesResponse,
    TemplateControllerUpdateTemplatesError,
    Schemas.UpdateManyTemplateDto,
    {},
    {},
    TemplateControllerUpdateTemplatesPathParams
  >({
    url: '/organizations/{id}/templates',
    method: 'patch',
    ...variables,
    signal,
  });

export const useTemplateControllerUpdateTemplates = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      TemplateControllerUpdateTemplatesResponse,
      TemplateControllerUpdateTemplatesError,
      TemplateControllerUpdateTemplatesVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    TemplateControllerUpdateTemplatesResponse,
    TemplateControllerUpdateTemplatesError,
    TemplateControllerUpdateTemplatesVariables
  >(
    (variables: TemplateControllerUpdateTemplatesVariables) =>
      fetchTemplateControllerUpdateTemplates({
        ...fetcherOptions,
        ...variables,
      }),
    options,
  );
};

export type TemplateControllerDeleteTemplatesPathParams = {
  id: string;
};

export type TemplateControllerDeleteTemplatesError =
  Fetcher.ErrorWrapper<undefined>;

export type TemplateControllerDeleteTemplatesVariables = {
  body: Schemas.DeleteManyTemplateDto;
  pathParams: TemplateControllerDeleteTemplatesPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchTemplateControllerDeleteTemplates = (
  variables: TemplateControllerDeleteTemplatesVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.BatchResponse,
    TemplateControllerDeleteTemplatesError,
    Schemas.DeleteManyTemplateDto,
    {},
    {},
    TemplateControllerDeleteTemplatesPathParams
  >({
    url: '/organizations/{id}/templates',
    method: 'delete',
    ...variables,
    signal,
  });

export const useTemplateControllerDeleteTemplates = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BatchResponse,
      TemplateControllerDeleteTemplatesError,
      TemplateControllerDeleteTemplatesVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    Schemas.BatchResponse,
    TemplateControllerDeleteTemplatesError,
    TemplateControllerDeleteTemplatesVariables
  >(
    (variables: TemplateControllerDeleteTemplatesVariables) =>
      fetchTemplateControllerDeleteTemplates({
        ...fetcherOptions,
        ...variables,
      }),
    options,
  );
};

export type RuleControllerGetRulesPathParams = {
  id: string;
};

export type RuleControllerGetRulesQueryParams = {
  take?: number;
  skip?: number;
};

export type RuleControllerGetRulesError = Fetcher.ErrorWrapper<undefined>;

export type RuleControllerGetRulesResponse = Schemas.Pagination & {
  items?: Schemas.SerializedRule[];
};

export type RuleControllerGetRulesVariables = {
  pathParams: RuleControllerGetRulesPathParams;
  queryParams?: RuleControllerGetRulesQueryParams;
} & InformApiContext['fetcherOptions'];

export const fetchRuleControllerGetRules = (
  variables: RuleControllerGetRulesVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    RuleControllerGetRulesResponse,
    RuleControllerGetRulesError,
    undefined,
    {},
    RuleControllerGetRulesQueryParams,
    RuleControllerGetRulesPathParams
  >({ url: '/organizations/{id}/rules', method: 'get', ...variables, signal });

export const useRuleControllerGetRules = <
  TData = RuleControllerGetRulesResponse,
>(
  variables: RuleControllerGetRulesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      RuleControllerGetRulesResponse,
      RuleControllerGetRulesError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<
    RuleControllerGetRulesResponse,
    RuleControllerGetRulesError,
    TData
  >(
    queryKeyFn({
      path: '/organizations/{id}/rules',
      operationId: 'ruleControllerGetRules',
      variables,
    }),
    ({ signal }) =>
      fetchRuleControllerGetRules({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type RuleControllerCreateRulePathParams = {
  id: string;
};

export type RuleControllerCreateRuleError = Fetcher.ErrorWrapper<undefined>;

export type RuleControllerCreateRuleVariables = {
  body: Schemas.CreateRuleDto;
  pathParams: RuleControllerCreateRulePathParams;
} & InformApiContext['fetcherOptions'];

export const fetchRuleControllerCreateRule = (
  variables: RuleControllerCreateRuleVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.SerializedRule,
    RuleControllerCreateRuleError,
    Schemas.CreateRuleDto,
    {},
    {},
    RuleControllerCreateRulePathParams
  >({ url: '/organizations/{id}/rules', method: 'post', ...variables, signal });

export const useRuleControllerCreateRule = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SerializedRule,
      RuleControllerCreateRuleError,
      RuleControllerCreateRuleVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    Schemas.SerializedRule,
    RuleControllerCreateRuleError,
    RuleControllerCreateRuleVariables
  >(
    (variables: RuleControllerCreateRuleVariables) =>
      fetchRuleControllerCreateRule({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type RuleControllerUpdateRulePathParams = {
  ruleId: string;
  id: string;
};

export type RuleControllerUpdateRuleError = Fetcher.ErrorWrapper<undefined>;

export type RuleControllerUpdateRuleVariables = {
  body: Schemas.UpdateRuleDto;
  pathParams: RuleControllerUpdateRulePathParams;
} & InformApiContext['fetcherOptions'];

export const fetchRuleControllerUpdateRule = (
  variables: RuleControllerUpdateRuleVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.SerializedRule,
    RuleControllerUpdateRuleError,
    Schemas.UpdateRuleDto,
    {},
    {},
    RuleControllerUpdateRulePathParams
  >({
    url: '/organizations/{id}/rules/{ruleId}',
    method: 'patch',
    ...variables,
    signal,
  });

export const useRuleControllerUpdateRule = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SerializedRule,
      RuleControllerUpdateRuleError,
      RuleControllerUpdateRuleVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    Schemas.SerializedRule,
    RuleControllerUpdateRuleError,
    RuleControllerUpdateRuleVariables
  >(
    (variables: RuleControllerUpdateRuleVariables) =>
      fetchRuleControllerUpdateRule({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type RuleControllerDeleteRulesPathParams = {
  ruleId: string;
  id: string;
};

export type RuleControllerDeleteRulesError = Fetcher.ErrorWrapper<undefined>;

export type RuleControllerDeleteRulesVariables = {
  pathParams: RuleControllerDeleteRulesPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchRuleControllerDeleteRules = (
  variables: RuleControllerDeleteRulesVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.BatchResponse,
    RuleControllerDeleteRulesError,
    undefined,
    {},
    {},
    RuleControllerDeleteRulesPathParams
  >({
    url: '/organizations/{id}/rules/{ruleId}',
    method: 'delete',
    ...variables,
    signal,
  });

export const useRuleControllerDeleteRules = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BatchResponse,
      RuleControllerDeleteRulesError,
      RuleControllerDeleteRulesVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    Schemas.BatchResponse,
    RuleControllerDeleteRulesError,
    RuleControllerDeleteRulesVariables
  >(
    (variables: RuleControllerDeleteRulesVariables) =>
      fetchRuleControllerDeleteRules({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type AiControllerGetAiConfigPathParams = {
  id: string;
};

export type AiControllerGetAiConfigError = Fetcher.ErrorWrapper<undefined>;

export type AiControllerGetAiConfigVariables = {
  pathParams: AiControllerGetAiConfigPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchAiControllerGetAiConfig = (
  variables: AiControllerGetAiConfigVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.SerializedAiConfig,
    AiControllerGetAiConfigError,
    undefined,
    {},
    {},
    AiControllerGetAiConfigPathParams
  >({ url: '/organizations/{id}/ai', method: 'get', ...variables, signal });

export const useAiControllerGetAiConfig = <TData = Schemas.SerializedAiConfig>(
  variables: AiControllerGetAiConfigVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SerializedAiConfig,
      AiControllerGetAiConfigError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<
    Schemas.SerializedAiConfig,
    AiControllerGetAiConfigError,
    TData
  >(
    queryKeyFn({
      path: '/organizations/{id}/ai',
      operationId: 'aiControllerGetAiConfig',
      variables,
    }),
    ({ signal }) =>
      fetchAiControllerGetAiConfig({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type AiControllerUpdateAiConfigPathParams = {
  id: string;
};

export type AiControllerUpdateAiConfigError = Fetcher.ErrorWrapper<undefined>;

export type AiControllerUpdateAiConfigVariables = {
  body?: Schemas.UpdateAiConfigDto;
  pathParams: AiControllerUpdateAiConfigPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchAiControllerUpdateAiConfig = (
  variables: AiControllerUpdateAiConfigVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.SerializedAiConfig,
    AiControllerUpdateAiConfigError,
    Schemas.UpdateAiConfigDto,
    {},
    {},
    AiControllerUpdateAiConfigPathParams
  >({ url: '/organizations/{id}/ai', method: 'patch', ...variables, signal });

export const useAiControllerUpdateAiConfig = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SerializedAiConfig,
      AiControllerUpdateAiConfigError,
      AiControllerUpdateAiConfigVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    Schemas.SerializedAiConfig,
    AiControllerUpdateAiConfigError,
    AiControllerUpdateAiConfigVariables
  >(
    (variables: AiControllerUpdateAiConfigVariables) =>
      fetchAiControllerUpdateAiConfig({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type MemberControllerGetMembersPathParams = {
  id: string;
};

export type MemberControllerGetMembersQueryParams = {
  take?: number;
  skip?: number;
};

export type MemberControllerGetMembersError = Fetcher.ErrorWrapper<undefined>;

export type MemberControllerGetMembersResponse = Schemas.Pagination & {
  items?: Schemas.SerializedMember[];
};

export type MemberControllerGetMembersVariables = {
  pathParams: MemberControllerGetMembersPathParams;
  queryParams?: MemberControllerGetMembersQueryParams;
} & InformApiContext['fetcherOptions'];

export const fetchMemberControllerGetMembers = (
  variables: MemberControllerGetMembersVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    MemberControllerGetMembersResponse,
    MemberControllerGetMembersError,
    undefined,
    {},
    MemberControllerGetMembersQueryParams,
    MemberControllerGetMembersPathParams
  >({
    url: '/organizations/{id}/members',
    method: 'get',
    ...variables,
    signal,
  });

export const useMemberControllerGetMembers = <
  TData = MemberControllerGetMembersResponse,
>(
  variables: MemberControllerGetMembersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      MemberControllerGetMembersResponse,
      MemberControllerGetMembersError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<
    MemberControllerGetMembersResponse,
    MemberControllerGetMembersError,
    TData
  >(
    queryKeyFn({
      path: '/organizations/{id}/members',
      operationId: 'memberControllerGetMembers',
      variables,
    }),
    ({ signal }) =>
      fetchMemberControllerGetMembers(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type MemberControllerAddMembersPathParams = {
  id: string;
};

export type MemberControllerAddMembersError = Fetcher.ErrorWrapper<undefined>;

export type MemberControllerAddMembersVariables = {
  body: Schemas.AddManyMemberDto;
  pathParams: MemberControllerAddMembersPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchMemberControllerAddMembers = (
  variables: MemberControllerAddMembersVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.BatchResponse,
    MemberControllerAddMembersError,
    Schemas.AddManyMemberDto,
    {},
    {},
    MemberControllerAddMembersPathParams
  >({
    url: '/organizations/{id}/members',
    method: 'post',
    ...variables,
    signal,
  });

export const useMemberControllerAddMembers = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BatchResponse,
      MemberControllerAddMembersError,
      MemberControllerAddMembersVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    Schemas.BatchResponse,
    MemberControllerAddMembersError,
    MemberControllerAddMembersVariables
  >(
    (variables: MemberControllerAddMembersVariables) =>
      fetchMemberControllerAddMembers({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type MemberControllerUpdateMembersPathParams = {
  id: string;
};

export type MemberControllerUpdateMembersError =
  Fetcher.ErrorWrapper<undefined>;

export type MemberControllerUpdateMembersResponse = Schemas.SerializedMember[];

export type MemberControllerUpdateMembersVariables = {
  body: Schemas.UpdateManyMemberDto;
  pathParams: MemberControllerUpdateMembersPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchMemberControllerUpdateMembers = (
  variables: MemberControllerUpdateMembersVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    MemberControllerUpdateMembersResponse,
    MemberControllerUpdateMembersError,
    Schemas.UpdateManyMemberDto,
    {},
    {},
    MemberControllerUpdateMembersPathParams
  >({
    url: '/organizations/{id}/members',
    method: 'patch',
    ...variables,
    signal,
  });

export const useMemberControllerUpdateMembers = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      MemberControllerUpdateMembersResponse,
      MemberControllerUpdateMembersError,
      MemberControllerUpdateMembersVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    MemberControllerUpdateMembersResponse,
    MemberControllerUpdateMembersError,
    MemberControllerUpdateMembersVariables
  >(
    (variables: MemberControllerUpdateMembersVariables) =>
      fetchMemberControllerUpdateMembers({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type MemberControllerRemoveMembersPathParams = {
  id: string;
};

export type MemberControllerRemoveMembersError =
  Fetcher.ErrorWrapper<undefined>;

export type MemberControllerRemoveMembersVariables = {
  body: Schemas.RemoveManyMemberDto;
  pathParams: MemberControllerRemoveMembersPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchMemberControllerRemoveMembers = (
  variables: MemberControllerRemoveMembersVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.BatchResponse,
    MemberControllerRemoveMembersError,
    Schemas.RemoveManyMemberDto,
    {},
    {},
    MemberControllerRemoveMembersPathParams
  >({
    url: '/organizations/{id}/members',
    method: 'delete',
    ...variables,
    signal,
  });

export const useMemberControllerRemoveMembers = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BatchResponse,
      MemberControllerRemoveMembersError,
      MemberControllerRemoveMembersVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    Schemas.BatchResponse,
    MemberControllerRemoveMembersError,
    MemberControllerRemoveMembersVariables
  >(
    (variables: MemberControllerRemoveMembersVariables) =>
      fetchMemberControllerRemoveMembers({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type WebhookControllerProcessChromeReviewPathParams = {
  id: string;
};

export type WebhookControllerProcessChromeReviewError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 201>;
  payload: Schemas.ProcessChromeReviewResponse;
}>;

export type WebhookControllerProcessChromeReviewVariables = {
  body: Schemas.ProcessChromeReviewDto;
  pathParams: WebhookControllerProcessChromeReviewPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchWebhookControllerProcessChromeReview = (
  variables: WebhookControllerProcessChromeReviewVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    undefined,
    WebhookControllerProcessChromeReviewError,
    Schemas.ProcessChromeReviewDto,
    {},
    {},
    WebhookControllerProcessChromeReviewPathParams
  >({
    url: '/organizations/{id}/webhooks/chrome',
    method: 'post',
    ...variables,
    signal,
  });

export const useWebhookControllerProcessChromeReview = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      WebhookControllerProcessChromeReviewError,
      WebhookControllerProcessChromeReviewVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    undefined,
    WebhookControllerProcessChromeReviewError,
    WebhookControllerProcessChromeReviewVariables
  >(
    (variables: WebhookControllerProcessChromeReviewVariables) =>
      fetchWebhookControllerProcessChromeReview({
        ...fetcherOptions,
        ...variables,
      }),
    options,
  );
};

export type WebhookControllerRunAutoReplyHeaders = {
  ['x-inform-token']: string;
};

export type WebhookControllerRunAutoReplyError =
  Fetcher.ErrorWrapper<undefined>;

export type WebhookControllerRunAutoReplyVariables = {
  headers: WebhookControllerRunAutoReplyHeaders;
} & InformApiContext['fetcherOptions'];

export const fetchWebhookControllerRunAutoReply = (
  variables: WebhookControllerRunAutoReplyVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    boolean,
    WebhookControllerRunAutoReplyError,
    undefined,
    WebhookControllerRunAutoReplyHeaders,
    {},
    {}
  >({
    url: '/organizations/{id}/webhooks/trigger/auto-reply',
    method: 'get',
    ...variables,
    signal,
  });

export const useWebhookControllerRunAutoReply = <TData = boolean>(
  variables: WebhookControllerRunAutoReplyVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      boolean,
      WebhookControllerRunAutoReplyError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<
    boolean,
    WebhookControllerRunAutoReplyError,
    TData
  >(
    queryKeyFn({
      path: '/organizations/{id}/webhooks/trigger/auto-reply',
      operationId: 'webhookControllerRunAutoReply',
      variables,
    }),
    ({ signal }) =>
      fetchWebhookControllerRunAutoReply(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type StatsControllerReviewStatsPathParams = {
  id: string;
};

export type StatsControllerReviewStatsQueryParams = {
  take?: number;
  skip?: number;
};

export type StatsControllerReviewStatsError = Fetcher.ErrorWrapper<undefined>;

export type StatsControllerReviewStatsResponse = Schemas.Pagination & {
  items?: Schemas.SerializedReviewStat[];
};

export type StatsControllerReviewStatsVariables = {
  pathParams: StatsControllerReviewStatsPathParams;
  queryParams?: StatsControllerReviewStatsQueryParams;
} & InformApiContext['fetcherOptions'];

export const fetchStatsControllerReviewStats = (
  variables: StatsControllerReviewStatsVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    StatsControllerReviewStatsResponse,
    StatsControllerReviewStatsError,
    undefined,
    {},
    StatsControllerReviewStatsQueryParams,
    StatsControllerReviewStatsPathParams
  >({
    url: '/organizations/{id}/stats/reviews',
    method: 'get',
    ...variables,
    signal,
  });

export const useStatsControllerReviewStats = <
  TData = StatsControllerReviewStatsResponse,
>(
  variables: StatsControllerReviewStatsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      StatsControllerReviewStatsResponse,
      StatsControllerReviewStatsError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<
    StatsControllerReviewStatsResponse,
    StatsControllerReviewStatsError,
    TData
  >(
    queryKeyFn({
      path: '/organizations/{id}/stats/reviews',
      operationId: 'statsControllerReviewStats',
      variables,
    }),
    ({ signal }) =>
      fetchStatsControllerReviewStats(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type WwwControllerContactError = Fetcher.ErrorWrapper<undefined>;

export type WwwControllerContactVariables = {
  body: Schemas.ContactDto;
} & InformApiContext['fetcherOptions'];

export const fetchWwwControllerContact = (
  variables: WwwControllerContactVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    boolean,
    WwwControllerContactError,
    Schemas.ContactDto,
    {},
    {},
    {}
  >({ url: '/www/contact', method: 'post', ...variables, signal });

export const useWwwControllerContact = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      boolean,
      WwwControllerContactError,
      WwwControllerContactVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    boolean,
    WwwControllerContactError,
    WwwControllerContactVariables
  >(
    (variables: WwwControllerContactVariables) =>
      fetchWwwControllerContact({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type ReviewsControllerReplyAllGoogleReviewsPathParams = {
  id: string;
};

export type ReviewsControllerReplyAllGoogleReviewsError =
  Fetcher.ErrorWrapper<undefined>;

export type ReviewsControllerReplyAllGoogleReviewsResponse = {
  [key: string]: Schemas.GoogleReviewReply;
};

export type ReviewsControllerReplyAllGoogleReviewsVariables = {
  pathParams: ReviewsControllerReplyAllGoogleReviewsPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchReviewsControllerReplyAllGoogleReviews = (
  variables: ReviewsControllerReplyAllGoogleReviewsVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    ReviewsControllerReplyAllGoogleReviewsResponse,
    ReviewsControllerReplyAllGoogleReviewsError,
    undefined,
    {},
    {},
    ReviewsControllerReplyAllGoogleReviewsPathParams
  >({
    url: '/organizations/{id}/reviews/google/replyAll',
    method: 'post',
    ...variables,
    signal,
  });

export const useReviewsControllerReplyAllGoogleReviews = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ReviewsControllerReplyAllGoogleReviewsResponse,
      ReviewsControllerReplyAllGoogleReviewsError,
      ReviewsControllerReplyAllGoogleReviewsVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    ReviewsControllerReplyAllGoogleReviewsResponse,
    ReviewsControllerReplyAllGoogleReviewsError,
    ReviewsControllerReplyAllGoogleReviewsVariables
  >(
    (variables: ReviewsControllerReplyAllGoogleReviewsVariables) =>
      fetchReviewsControllerReplyAllGoogleReviews({
        ...fetcherOptions,
        ...variables,
      }),
    options,
  );
};

export type ReviewsControllerReplyGoogleReviewPathParams = {
  id: string;
  reviewId: string;
};

export type ReviewsControllerReplyGoogleReviewError =
  Fetcher.ErrorWrapper<undefined>;

export type ReviewsControllerReplyGoogleReviewVariables = {
  body: Schemas.UpdateGoogleReviewDto;
  pathParams: ReviewsControllerReplyGoogleReviewPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchReviewsControllerReplyGoogleReview = (
  variables: ReviewsControllerReplyGoogleReviewVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.GoogleReviewReply,
    ReviewsControllerReplyGoogleReviewError,
    Schemas.UpdateGoogleReviewDto,
    {},
    {},
    ReviewsControllerReplyGoogleReviewPathParams
  >({
    url: '/organizations/{id}/reviews/google/{reviewId}',
    method: 'post',
    ...variables,
    signal,
  });

export const useReviewsControllerReplyGoogleReview = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.GoogleReviewReply,
      ReviewsControllerReplyGoogleReviewError,
      ReviewsControllerReplyGoogleReviewVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useInformApiContext();
  return reactQuery.useMutation<
    Schemas.GoogleReviewReply,
    ReviewsControllerReplyGoogleReviewError,
    ReviewsControllerReplyGoogleReviewVariables
  >(
    (variables: ReviewsControllerReplyGoogleReviewVariables) =>
      fetchReviewsControllerReplyGoogleReview({
        ...fetcherOptions,
        ...variables,
      }),
    options,
  );
};

export type ReviewsControllerGoogleReviewsPathParams = {
  id: string;
};

export type ReviewsControllerGoogleReviewsQueryParams = {
  nextPageToken?: string;
};

export type ReviewsControllerGoogleReviewsError =
  Fetcher.ErrorWrapper<undefined>;

export type ReviewsControllerGoogleReviewsVariables = {
  pathParams: ReviewsControllerGoogleReviewsPathParams;
  queryParams?: ReviewsControllerGoogleReviewsQueryParams;
} & InformApiContext['fetcherOptions'];

export const fetchReviewsControllerGoogleReviews = (
  variables: ReviewsControllerGoogleReviewsVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.SerializedGoogleResponse,
    ReviewsControllerGoogleReviewsError,
    undefined,
    {},
    ReviewsControllerGoogleReviewsQueryParams,
    ReviewsControllerGoogleReviewsPathParams
  >({
    url: '/organizations/{id}/reviews/google',
    method: 'get',
    ...variables,
    signal,
  });

export const useReviewsControllerGoogleReviews = <
  TData = Schemas.SerializedGoogleResponse,
>(
  variables: ReviewsControllerGoogleReviewsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SerializedGoogleResponse,
      ReviewsControllerGoogleReviewsError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<
    Schemas.SerializedGoogleResponse,
    ReviewsControllerGoogleReviewsError,
    TData
  >(
    queryKeyFn({
      path: '/organizations/{id}/reviews/google',
      operationId: 'reviewsControllerGoogleReviews',
      variables,
    }),
    ({ signal }) =>
      fetchReviewsControllerGoogleReviews(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type ReportControllerGetWeeklyReportPathParams = {
  id: string;
};

export type ReportControllerGetWeeklyReportError =
  Fetcher.ErrorWrapper<undefined>;

export type ReportControllerGetWeeklyReportVariables = {
  pathParams: ReportControllerGetWeeklyReportPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchReportControllerGetWeeklyReport = (
  variables: ReportControllerGetWeeklyReportVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    Schemas.SerializedReport,
    ReportControllerGetWeeklyReportError,
    undefined,
    {},
    {},
    ReportControllerGetWeeklyReportPathParams
  >({
    url: '/organizations/{id}/report/weekly',
    method: 'get',
    ...variables,
    signal,
  });

export const useReportControllerGetWeeklyReport = <
  TData = Schemas.SerializedReport,
>(
  variables: ReportControllerGetWeeklyReportVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SerializedReport,
      ReportControllerGetWeeklyReportError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<
    Schemas.SerializedReport,
    ReportControllerGetWeeklyReportError,
    TData
  >(
    queryKeyFn({
      path: '/organizations/{id}/report/weekly',
      operationId: 'reportControllerGetWeeklyReport',
      variables,
    }),
    ({ signal }) =>
      fetchReportControllerGetWeeklyReport(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type ReportControllerGetWeeklyReportHistoryPathParams = {
  id: string;
};

export type ReportControllerGetWeeklyReportHistoryError =
  Fetcher.ErrorWrapper<undefined>;

export type ReportControllerGetWeeklyReportHistoryResponse =
  Schemas.GraphData[];

export type ReportControllerGetWeeklyReportHistoryVariables = {
  pathParams: ReportControllerGetWeeklyReportHistoryPathParams;
} & InformApiContext['fetcherOptions'];

export const fetchReportControllerGetWeeklyReportHistory = (
  variables: ReportControllerGetWeeklyReportHistoryVariables,
  signal?: AbortSignal,
) =>
  informApiFetch<
    ReportControllerGetWeeklyReportHistoryResponse,
    ReportControllerGetWeeklyReportHistoryError,
    undefined,
    {},
    {},
    ReportControllerGetWeeklyReportHistoryPathParams
  >({
    url: '/organizations/{id}/report/weekly/history',
    method: 'get',
    ...variables,
    signal,
  });

export const useReportControllerGetWeeklyReportHistory = <
  TData = ReportControllerGetWeeklyReportHistoryResponse,
>(
  variables: ReportControllerGetWeeklyReportHistoryVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ReportControllerGetWeeklyReportHistoryResponse,
      ReportControllerGetWeeklyReportHistoryError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useInformApiContext(options);
  return reactQuery.useQuery<
    ReportControllerGetWeeklyReportHistoryResponse,
    ReportControllerGetWeeklyReportHistoryError,
    TData
  >(
    queryKeyFn({
      path: '/organizations/{id}/report/weekly/history',
      operationId: 'reportControllerGetWeeklyReportHistory',
      variables,
    }),
    ({ signal }) =>
      fetchReportControllerGetWeeklyReportHistory(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type QueryOperation =
  | {
      path: '/';
      operationId: 'appControllerGetHello';
      variables: AppControllerGetHelloVariables;
    }
  | {
      path: '/users/me';
      operationId: 'userControllerGetMe';
      variables: UserControllerGetMeVariables;
    }
  | {
      path: '/auth/google';
      operationId: 'authControllerGoogleAuth';
      variables: AuthControllerGoogleAuthVariables;
    }
  | {
      path: '/organizations';
      operationId: 'organizationControllerGetMyOrganizations';
      variables: OrganizationControllerGetMyOrganizationsVariables;
    }
  | {
      path: '/organizations/{id}';
      operationId: 'organizationControllerGetOrganization';
      variables: OrganizationControllerGetOrganizationVariables;
    }
  | {
      path: '/organizations/{id}/templates';
      operationId: 'templateControllerGetTemplates';
      variables: TemplateControllerGetTemplatesVariables;
    }
  | {
      path: '/organizations/{id}/rules';
      operationId: 'ruleControllerGetRules';
      variables: RuleControllerGetRulesVariables;
    }
  | {
      path: '/organizations/{id}/ai';
      operationId: 'aiControllerGetAiConfig';
      variables: AiControllerGetAiConfigVariables;
    }
  | {
      path: '/organizations/{id}/members';
      operationId: 'memberControllerGetMembers';
      variables: MemberControllerGetMembersVariables;
    }
  | {
      path: '/organizations/{id}/webhooks/trigger/auto-reply';
      operationId: 'webhookControllerRunAutoReply';
      variables: WebhookControllerRunAutoReplyVariables;
    }
  | {
      path: '/organizations/{id}/stats/reviews';
      operationId: 'statsControllerReviewStats';
      variables: StatsControllerReviewStatsVariables;
    }
  | {
      path: '/organizations/{id}/reviews/google';
      operationId: 'reviewsControllerGoogleReviews';
      variables: ReviewsControllerGoogleReviewsVariables;
    }
  | {
      path: '/organizations/{id}/report/weekly';
      operationId: 'reportControllerGetWeeklyReport';
      variables: ReportControllerGetWeeklyReportVariables;
    }
  | {
      path: '/organizations/{id}/report/weekly/history';
      operationId: 'reportControllerGetWeeklyReportHistory';
      variables: ReportControllerGetWeeklyReportHistoryVariables;
    };
